import { Component, OnInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import{ApiService} from '../../services/api.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.page.html',
  styleUrls: ['./calendar.page.scss'],
})
export class CalendarPage implements OnInit {

	mode: string = 'next';

  constructor(public actionSheetController: ActionSheetController, private api:ApiService) { }

  ngOnInit() {
      this.getData(null);
  }

  page:any=1;
  moreData:boolean=true;
  dataAgenda:any=[];
  arsip:any=[];
  loading:boolean;
  getData(ev)
  {
      this.loading=true;
      var keyApp=localStorage.getItem('keyApp');
      this.api.data('agenda?page='+this.page+'&key_app='+keyApp,'get','').subscribe(data=>{
        this.loading=false;
        this.page=this.page+1;
        this.parseDataAgenda(data);
        
      })
  }
  parseDataAgenda(data)
  {
      var today=new Date();
      for(var i=0;i<data.length;i++)
      {
        data[i].mulai=new Date(data[i].mulai);
        if(data[i].mulai.getTime() > today.getTime())
        this.dataAgenda.push(data[i]);
        else
        this.arsip.push(data[i]);
      }
      
  } 


}
